import { Box } from '@mui/material';
import { useState, useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import ModalBase from '../../../components/Controls/ModalBase';
import videoPWA from '../../../assets/videos/pwaiOS.mp4';

const ManualDescargarAppApple = () => {
  return (
    <Box>
      <p>Siga estos tres simples pasos para instalar la aplicación.</p>
      <ol>
        <li>
          Toca el icono <strong>Compartir</strong> del navegador de su dispositivo.
        </li>
        <li>
          Seleccione <strong>Agregar</strong> a la pantalla de inicio de las opciones.
        </li>
        <li>
          Confirme la instalación tocando el botón <strong>Agregar</strong>.
        </li>
      </ol>
      <Box sx={{ display: 'flex', justifyContent: 'center', py: '15px' }}>
        <video
          loading='lazy'
          autoPlay
          loop
          muted
          style={{ width: '100%', maxWidth: '400px', borderRadius: '30px' }}
        >
          <source src={videoPWA} type='video/mp4' />
        </video>
      </Box>
    </Box>
  );
};

export const ButtonDownloadPWAiOS = ({ isMobile, ...props }) => {
  const [open, setOpen] = useState(false);
  const history = useHistory();

  // Detectar dispositivo solo una vez al montar, memoizado
  const isApple = useMemo(() => {
    const dataUserAgent = window.navigator.userAgent;
    const dataPlatform = navigator.platform;

    const isIOSDevice = /iPhone|iPad/i.test(dataUserAgent);
    const isMacOS = dataPlatform.toUpperCase().indexOf('MAC') >= 0 || /Mac/i.test(dataUserAgent);

    return isIOSDevice || isMacOS;
  }, []);

  // useCallback para memoizar la función
  const handleOpenModal = useCallback(() => {
    // Si es mobile, redirige a página de manual de instalación, sino abre el modal
    if (isMobile) {
      history.push('/manual-instalacion-ios');
      return;
    }

    setOpen(true);
  }, [isMobile, history]);

  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, []);

  // Solo renderizar si es Apple
  if (!isApple) {
    return null;
  }

  return (
    <>
      <Box onClick={handleOpenModal} sx={{ cursor: 'pointer' }}>
        {props.children}
      </Box>

      <ModalBase
        open={open}
        content={<ManualDescargarAppApple />}
        title={
          <Box sx={{ mr: { xs: 5, sm: 10 } }}>¿Cómo instalar mi.OSER en dispositivos Apple?</Box>
        }
        onClose={handleCloseModal}
      />
    </>
  );
};
